import { modal } from '@mx/vix';
import { bridge, analytics } from '@/common';
import { analyticConfig } from '@/config/analyticConfig';

export function riskModal(data: RiskControlAlertType, closePage: boolean = false) {
  setTimeout(() => {
    analytics.mv(analyticConfig.riskModal.mv, {
      popup_type: '功能关闭弹弹窗',
    });
  }, 500);
  modal.show({
    title: data.title,
    content: data.body,
    preventScroll: true,
    button: {
      text: data.buttonText,
      onClick: () => {
        if (closePage) bridge.closePage();
        modal.hide();
      },
    },
  });
}
